import React from "react";
import { NextButton } from "../../components/NextButton/NextButton";
import { ProjectsContent } from "../../components/ProjectsContent/ProjectsContent";
const Projects = () => {
  return (
    <>
      <ProjectsContent />
      <NextButton nextRoute="/contact" />
    </>
  );
};

export default Projects;
